import React from 'react';

const environment = process.env.REACT_APP_ENVIRONMENT || 'development';

export const EnvironmentBanner: React.FC = () => {
  // Only show banner for non-production environments
  if (environment === 'production') {
    return null;
  }

  const config: Record<string, { label: string; bgColor: string; textColor: string }> = {
    demo: {
      label: 'DEMO-MILJØ - Dette er et testmiljø',
      bgColor: 'bg-orange-500',
      textColor: 'text-white'
    },
    development: {
      label: 'UTVIKLINGSMILJØ',
      bgColor: 'bg-blue-600',
      textColor: 'text-white'
    }
  };

  const { label, bgColor, textColor } = config[environment] || config.development;

  return (
    <div className={`${bgColor} ${textColor} text-center py-1.5 text-sm font-semibold`}>
      {label}
    </div>
  );
};
